export default class ShiftAcceptanceNotificationModalCtrl {
  constructor(
    ShiftAcceptanceUtils,
    EventCollection,
    $uibModalInstance,
    /* resolves */ notification
  ) {
    'ngInject';

    Object.assign(this, { ShiftAcceptanceUtils, EventCollection, $uibModalInstance, notification });
    this.shifts = notification?.items || [];
  }

  async rejectShift(shift) {
    await this.ShiftAcceptanceUtils.rejectShift(shift);
    this.removeShift(shift);
  }

  async acceptShift(shift) {
    await this.EventCollection.acceptShift(shift);
    this.removeShift(shift);
  }

  removeShift(shift) {
    this.shifts = this.shifts.filter((e) => e.id !== shift.id);
    if (!this.shifts.length) {
      this.$uibModalInstance.close();
    }
  }

  async acceptAllShifts() {
    const shiftIds = this.shifts.map((e) => e.id);
    await this.EventCollection.bulkAcceptShifts(shiftIds);

    this.$uibModalInstance.close();
  }
}
